module.exports = {"version":"4.3.3-g5ca530e","supportedLanguages":["en","cs","da","de","el","es","fi","fr","hu","id","in","it","ja","ko","ms","nb","nl-NL","pl","pt-BR","ro","ru","sv","th","tr","uk","vi","zh-CN","zh-TW"]}


//////////////////
// WEBPACK FOOTER
// ./src/config/config.json
// module id = 42
// module chunks = 0